<app-plant-filters
  (filterChange)="onFilterSelectionChange($event)"
></app-plant-filters>
